import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import classNames from "classnames";

// Components
import Paragraph from "../../Atoms/Paragraph";
import TabletSubNavigation from "./Components/TabletSubNavigation";
import MobileNavigation from "./Components/MobileNavigation";

// Stylesheets
import styles from "./style.module.scss";
import "./CartOverrides.scss";

// Utils
import { Mobile, TabletOrDesktop } from "../../Utils/ResponsiveComponent";
import HatchLogo from "../../Atoms/HatchLogo";
import CartIcon from "../../Atoms/CartIcon";
import HamburgerIcon from "../../Atoms/HamburgerIcon";

export const SuperNavigation = () => {
  const [subNavigationIsOpen, setSubNavigationIsOpen] = useState(false);
  const history = useHistory();

  //only use this if on Desktop
  const handleOnMouse = (state) => {
    if (window.screen.width > 767) {
      setSubNavigationIsOpen(state);
    }
  };

  useEffect(() => {
    //close navigation on route change
    let unlisten = history.listen((location, action) => {
      setSubNavigationIsOpen(false);
    });
    return () => {
      // Anything in here is fired on component unmount.
      unlisten();
    };
  }, [history]);

  const body = document.querySelector("body");

  useEffect(() => {
    if (subNavigationIsOpen) {
      // Disable scroll
      body.style.overflow = "hidden";
    } else {
      // Enable scroll
      body.style.overflow = "auto";
    }
  }, [subNavigationIsOpen, body.style]);

  return (
    <>
      <nav className={styles.superNavigation}>
        <div
          className={classNames(styles.superNavigation_container, "container")}
        >
          <div className={styles.superNavigation_bar}>
            <ul
              className={classNames(
                styles.superNavigation_menu,
                styles.listReset
              )}
            >
              <li className={styles.superNavigation_menuItem}>
                {subNavigationIsOpen}
                <TabletOrDesktop>
                  <button
                    onMouseEnter={() => handleOnMouse(true)}
                    onClick={() => setSubNavigationIsOpen(!subNavigationIsOpen)}
                    className={classNames(
                      styles.superNavigation_subMenuToggle,
                      subNavigationIsOpen
                        ? styles.superNavigation_subMenuToggleActive
                        : "",
                      styles.buttonReset
                    )}
                    type="button"
                    aria-expanded={!subNavigationIsOpen ? true : false}
                  >
                    <Paragraph className="body_primary">
                      Shop Smart Sleep Devices
                    </Paragraph>
                  </button>
                </TabletOrDesktop>
                <Mobile>
                  <HamburgerIcon
                    onClick={() => {
                      setSubNavigationIsOpen(!subNavigationIsOpen);
                    }}
                    isOpen={subNavigationIsOpen}
                  />
                </Mobile>
              </li>
            </ul>
            <div className={styles.superNavigation_logo}>
              <HatchLogo />
            </div>
            <ul
              className={classNames(
                styles.superNavigation_utilityNavigation,
                styles.listReset
              )}
            >
              <li>
                <div className="cart_wrapper">
                  <CartIcon />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          className={classNames(
            styles.superNavigation_subNavigation,
            subNavigationIsOpen ? styles.superNavigation_subNavigationOpen : ""
          )}
          onMouseLeave={() => {
            handleOnMouse(false);
          }}
        >
          <TabletOrDesktop>
            <TabletSubNavigation navState={subNavigationIsOpen} />
          </TabletOrDesktop>
          <Mobile>
            <MobileNavigation navState={subNavigationIsOpen} />
          </Mobile>
        </div>
      </nav>
      <div
        className={classNames(
          styles.superNavigation_backdrop,
          subNavigationIsOpen ? styles.superNavigation_backdropActive : ""
        )}
      ></div>
    </>
  );
};

export default SuperNavigation;
